var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7719 48.7719C52.25 45.2938 52.25 39.6959 52.25 28.5C52.25 17.3041 52.25 11.7062 48.7719 8.22811C45.2938 4.75 39.6959 4.75 28.5 4.75C17.3041 4.75 11.7062 4.75 8.22811 8.22811C4.75 11.7062 4.75 17.3041 4.75 28.5C4.75 39.6959 4.75 45.2938 8.22811 48.7719C11.7062 52.25 17.3041 52.25 28.5 52.25C39.6959 52.25 45.2938 52.25 48.7719 48.7719ZM35.2175 20.0012C36.2013 20.0012 36.9988 20.7987 36.9988 21.7825V31.8588C36.9988 32.8425 36.2013 33.64 35.2175 33.64C34.2338 33.64 33.4363 32.8425 33.4363 31.8588L33.4363 26.0828L23.042 36.4771C22.3464 37.1727 21.2186 37.1727 20.523 36.4771C19.8273 35.7814 19.8273 34.6536 20.523 33.958L30.9172 23.5637H25.1412C24.1575 23.5637 23.36 22.7662 23.36 21.7825C23.36 20.7987 24.1575 20.0012 25.1412 20.0012L35.2175 20.0012Z",
    fill: "#41B64D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowLink);
export default __webpack_public_path__ + "static/media/followLink.c2bd769d5a93da12fe309be2966c218e.svg";
export { ForwardRef as ReactComponent };